import { AgreenaSection } from "./agreena-section";
import { ArticlePage } from "./article-page";
import { BannerSection } from "./banner-section";
import { BenefitsSection } from "./benefits-section";
import { CarbonCreditsSection } from "./carbon-credits-section";
import { ContactSection } from "./contact-section";
import { CropDropSection } from "./crop-drop-section";
import { CtaItem } from "./cta-item/cta-item";
import { DocPage } from "./doc-page";
import { DynamicPage } from "./dynamic-page";
import { FAQSection } from "./faq-section";
import { FeaturesSection } from "./features-section";
import { GridSection } from "./grid-section";
import { HeroSection } from "./hero-section";
import { HubspotFormSection } from "./hubspot-form-section";
import { ImageItem } from "./image-item/image-item";
import { ImageSection } from "./image-section";
import { InfoPage } from "./info-page";
import { LinkSection } from "./link-section";
import { LogoSection } from "./logo-section";
import { MapSection } from "./map-section";
import { MarketingMessage } from "./marketing-message/marketing-message";
import { MigrationExpandableTilesSection } from "./migration-expandable-tiles-section";
import { MigrationExpandableTile } from "./migration-expandable-tiles-section/migration-expandable-tile";
import { MigrationHelpSection } from "./migration-help-section";
import { MigrationHeroSection } from "./migration-hero-section";
import { MigrationInvestorsSection } from "./migration-investors-section";
import { MigrationMissionSection } from "./migration-mission-section";
import { MigrationPersonDetailsCardsSection } from "./migration-person-details-cards-section";
import { MigrationPersonGridSection } from "./migration-person-grid-section";
import { MigrationSideBySideSection } from "./migration-side-by-side-section";
import { MigrationTextSection } from "./migration-text-section";
import { MigrationVideoSection } from "./migration-video-section";
import { NewsPage } from "./news-page";
import { PersonSection } from "./person-section";
import { PitchItem, PitchSection } from "./pitch-section";
import { PressReleasePage } from "./press-release-page";
import { QuoteSection } from "./quote-section";
import { HubspotForm } from "./rich-text";
import { Tiles } from "./rich-text/tiles/tiles";
import { Video } from "./rich-text/video/video";
import { SectionBlockHeader } from "./section-block-header/section-block-header";
import { SectionCarousel } from "./section-carousel/section-carousel";
import { SectionEventsItem } from "./section-events-item/section-events-item";
import { SectionEvents } from "./section-events/section-events";
import { SectionStack } from "./section-stack/section-stack";
import { SectionSteps } from "./section-steps/section-steps";
import { SeedSection } from "./seed-section";
import { ShowcaseSection } from "./showcase-section";
import { SimpleHeaderSection } from "./simple-header-section/simple-header-section";
import { SlidesSection } from "./slides-section";
import { SplitSection } from "./split-section";
import { StatsSection, StatsSectionItem } from "./stats-section";
import { TextSection } from "./text-section";
import { TileSection } from "./tile-section";
import { TypeformSection } from "./typeform-section";
import { VideoSection } from "./video-section";
import { VideoSectionBackground } from "./video-section-background";

export const cmsComponents = {
  AgreenaSection,
  ArticlePage,
  BannerSection,
  BenefitsSection,
  CarbonCreditsSection,
  Config: () => null,
  ContactSection,
  CropDropSection,
  DocPage,
  DynamicPage,
  FAQSection,
  FeaturesSection,
  GridSection,
  HeroSection,
  HubspotForm,
  HubspotFormSection,
  ImageSection,
  InfoPage,
  SeedSection,
  LinkSection,
  LogoSection,
  MapSection,
  MigrationExpandableTile,
  MigrationExpandableTilesSection,
  MigrationHeroSection,
  MigrationMissionSection,
  MigrationPersonDetailsCardsSection,
  MigrationPersonGridSection,
  MigrationSideBySideSection,
  MigrationVideoSection,
  MigrationInvestorsSection,
  MigrationHelpSection,
  MigrationTextSection,
  NewsPage,
  PersonSection,
  PitchItem,
  PitchSection,
  PressReleasePage,
  QuoteSection,
  ShowcaseSection,
  SlidesSection,
  SplitSection,
  TileSection,
  Tiles,
  TextSection,
  TypeformSection,
  Video,
  VideoSection,
  VideoSectionBackground,
  StatsSection,
  StatsSectionItem,
  SimpleHeaderSection,
  CtaItem,
  SectionBlockHeader,
  SectionStack,
  SectionSteps,
  ImageItem,
  SectionCarousel,
  SectionEvents,
  SectionEventsItem,
  MarketingMessage,
};
